import { render, staticRenderFns } from "./showVideo.vue?vue&type=template&id=f0bc874a&scoped=true"
import script from "./showVideo.vue?vue&type=script&lang=js"
export * from "./showVideo.vue?vue&type=script&lang=js"
import style0 from "./showVideo.vue?vue&type=style&index=0&id=f0bc874a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bc874a",
  null
  
)

export default component.exports